import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PHK3 from './Components/PHK3';
import PHK4 from './Components/PHK4';

const zonatData = [
  {
    id: "B-01-K4",
    path: "M960.5 311V770.5H1140V546H1207.5V496H1107V311H960.5Z", 
    link: "/detajet-b01",
    images: [
      "/images/Bazat 2D dhe 3D k3&4/L4/L4 -K1 -05.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/01.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/02.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/03.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/04.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/05.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/06.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/07.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/08.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/09.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/10.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/11.jpg"
    ],
    vrPaths: {
      "1": "https://hitimperial.github.io/vr-new/%E2%80%A2%203%20-%20TIPI%2002%20-%20K4/Tipi%2002%20-%20N1%20K4%20-%20Kati%201%20-%20Gjlerbrim/",
      "2": "https://hitimperial.github.io/vr-new/%E2%80%A2%203%20-%20TIPI%2002%20-%20K4/Tipi%2002%20-%20N1%20K4%20-%20Kati%202-3/",
      "3": "https://hitimperial.github.io/vr-new/%E2%80%A2%203%20-%20TIPI%2002%20-%20K4/Tipi%2002%20-%20N1%20K4%20-%20Kati%202-3/",
      "4": "https://hitimperial.github.io/vr-new/%E2%80%A2%203%20-%20TIPI%2002%20-%20K4/Tipi%2002%20-%20N2%20K4%20-%20Kati%204-5-6/",
      "5": "https://hitimperial.github.io/vr-new/%E2%80%A2%203%20-%20TIPI%2002%20-%20K4/Tipi%2002%20-%20N2%20K4%20-%20Kati%204-5-6/",
      "6": "https://hitimperial.github.io/vr-new/%E2%80%A2%203%20-%20TIPI%2002%20-%20K4/Tipi%2002%20-%20N2%20K4%20-%20Kati%204-5-6/",
      "7": "https://hitimperial.github.io/vr-new/%E2%80%A2%203%20-%20TIPI%2002%20-%20K4/Tipi%2002%20-%20N3%20K4%20-%20Kati%207-8-9/",
      "8": "https://hitimperial.github.io/vr-new/%E2%80%A2%203%20-%20TIPI%2002%20-%20K4/Tipi%2002%20-%20N3%20K4%20-%20Kati%207-8-9/",
      "9": "https://hitimperial.github.io/vr-new/%E2%80%A2%203%20-%20TIPI%2002%20-%20K4/Tipi%2002%20-%20N3%20K4%20-%20Kati%207-8-9/",
      "10": "https://hitimperial.github.io/vr-new/%E2%80%A2%203%20-%20TIPI%2002%20-%20K4/Tipi%2002%20-%20N4%20K4%20-%20Kati%2010-11-12/",
      "11": "https://hitimperial.github.io/vr-new/%E2%80%A2%203%20-%20TIPI%2002%20-%20K4/Tipi%2002%20-%20N4%20K4%20-%20Kati%2010-11-12/",
      "12": "https://hitimperial.github.io/vr-new/%E2%80%A2%203%20-%20TIPI%2002%20-%20K4/Tipi%2002%20-%20N4%20K4%20-%20Kati%2010-11-12/"
    }
  },
  {
    id: "B-02-K4",
    path: "M1105 308V499H1305V308H1105Z", 
    link: "/detajet-b02",
    images: [
      "/images/Bazat 2D dhe 3D k3&4/L4/L4 -K1 -06.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/01.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/02.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/03.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/04.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/05.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/06.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/07.jpg"
    ],
    vrPaths: {
      "1": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N1%20-%20gjelberim/",
      "2": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N1/",
      "3": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N1/",
      "4": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N2/",
      "5": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N2/",
      "6": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N2/",
      "7": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N3/",
      "8": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N3/",
      "9": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N3/",
      "10": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N4/",
      "11": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N4/",
      "12": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N4/"
    }
  },
  {
    id: "B-03-K4",
    path: "M1131 540V772H1380V540H1131Z", 
    link: "/detajet-b03",
    images: [
      "/images/Bazat 2D dhe 3D k3&4/L4/L4 -K1-K12 -04.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/1.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/2.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/3.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/4.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/5.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/6.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/7.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/8.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/9.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/10.jpg"
    ],
    vrPaths: {
      "1": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N1%20K4%20-%20Kati%201-2-3/",
      "2": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N1%20K4%20-%20Kati%201-2-3/",
      "3": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N1%20K4%20-%20Kati%201-2-3/",
      "4": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N2%20K4%20-%20Kati%204-5-6/",
      "5": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N2%20K4%20-%20Kati%204-5-6/",
      "6": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N2%20K4%20-%20Kati%204-5-6/",
      "7": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N3%20K4%20-%20Kati%207-8-9/",
      "8": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N3%20K4%20-%20Kati%207-8-9/",
      "9": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N3%20K4%20-%20Kati%207-8-9/",
      "10": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N4%20K4%20-%20Kati%2010-11-12/",
      "11": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N4%20K4%20-%20Kati%2010-11-12/",
      "12": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N4%20K4%20-%20Kati%2010-11-12/"
    }
  },
  {
    id: "B-04-K4",
    path: "M1381 544V770H1624.5V544H1381Z", 
    link: "/detajet-b04",
    images: [
      "/images/Bazat 2D dhe 3D k3&4/L4/L4 -K1-K12 -03.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/1.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/2.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/3.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/4.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/5.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/6.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/7.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/8.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/9.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tip 01 - K4 - Foto VR/10.jpg"
    ],
    vrPaths: {
      "1": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N1%20K4%20-%20Kati%201-2-3/",
      "2": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N1%20K4%20-%20Kati%201-2-3/",
      "3": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N1%20K4%20-%20Kati%201-2-3/",
      "4": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N2%20K4%20-%20Kati%204-5-6/",
      "5": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N2%20K4%20-%20Kati%204-5-6/",
      "6": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N2%20K4%20-%20Kati%204-5-6/",
      "7": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N3%20K4%20-%20Kati%207-8-9/",
      "8": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N3%20K4%20-%20Kati%207-8-9/",
      "9": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N3%20K4%20-%20Kati%207-8-9/",
      "10": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N4%20K4%20-%20Kati%2010-11-12/",
      "11": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N4%20K4%20-%20Kati%2010-11-12/",
      "12": "https://hitimperial.github.io/vr-new/%E2%80%A2%201%20-%20Tip%2001%20-%20K4/Tipi%2001%20-%20N4%20K4%20-%20Kati%2010-11-12/"
    }
  },
  {
    id: "B-05-K4",
    path: "M1455 306V496H1655V306H1455Z", 
    link: "/detajet-b05",
    images: [
      "/images/Bazat 2D dhe 3D k3&4/L4/L4 -K1-K12 -07.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/01.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/02.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/03.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/04.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/05.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/06.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/07.jpg"
    ],
    vrPaths: {
      "1": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N1%20-%20gjelberim/",
      "2": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N1/",
      "3": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N1/",
      "4": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N2/",
      "5": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N2/",
      "6": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N2/",
      "7": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N3/",
      "8": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N3/",
      "9": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N3/",
      "10": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N4/",
      "11": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N4/",
      "12": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N4/"
    }
  },
  {
    id: "B-06-K4",
    path: "M1656 307v189h-104v47.5h72.5V774h179.5V307H1656z", 
    link: "/detajet-b06",
    images: [
      "/images/Bazat 2D dhe 3D k3&4/L4/L4 -K2-K12 -08.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/01.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/02.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/03.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/04.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/05.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/06.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/07.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/08.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/09.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/10.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/11.jpg"
    ],
    vrPaths: {
      "1": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N1%20-%20gjelberim/",
      "2": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N1/",
      "3": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N1/",
      "4": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N2/",
      "5": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N2/",
      "6": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N2/",
      "7": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N3/",
      "8": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N3/",
      "9": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N3/",
      "10": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N4/",
      "11": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N4/",
      "12": "https://hitimperial.github.io/vr-new/%E2%80%A2%202%20-%20.Tipi%2003%20-%20K4/N4/"
    }
  },
  {
    id: "A-04-K3",
    path: "M956 309v210H854.5v16.5h-42.5v-19H765v-21.5h-95V309h286z", 
    link: "/detajet-a04",
    images: ["/images/Bazat 2D dhe 3D k3&4/L3/L3 -K1 -01.jpg"],
    vrPaths: {
      "1": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N1%20-%20Terasat/", 
      "2": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N1/",
      "3": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N1/",
      "4": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N2/",
      "5": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N2/",
      "6": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N2/",
      "7": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N3/",
      "8": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N3/",
      "9": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N3/",
      "10": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N4/",
      "11": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N4/",
      "12": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N4/"
    }
  },
  {
    id: "A-05-K3",
    path: "M954.5 519.5H853.8v17.9H810.3v-16.9L765.4 521v25.4H714.5v221.6l243 1.5", 
    link: "/detajet-a05",
    images: ["/images/Bazat 2D dhe 3D k3&4/L3/L3 -K1-12-02.jpg"],
    vrPaths: {
      "1": "https://hitimperial.github.io/vr-new/L3%20-%20K1-K12%20-%20104.06%20m2/Publish%20N1/",
      "2": "https://hitimperial.github.io/vr-new/L3%20-%20K1-K12%20-%20104.06%20m2/Publish%20N1/",
      "3": "https://hitimperial.github.io/vr-new/L3%20-%20K1-K12%20-%20104.06%20m2/Publish%20N1/",
      "4": "https://hitimperial.github.io/vr-new/L3%20-%20K1-K12%20-%20104.06%20m2/Publish%20N2/",
      "5": "https://hitimperial.github.io/vr-new/L3%20-%20K1-K12%20-%20104.06%20m2/Publish%20N2/",
      "6": "https://hitimperial.github.io/vr-new/L3%20-%20K1-K12%20-%20104.06%20m2/Publish%20N2/",
      "7": "https://hitimperial.github.io/vr-new/L3%20-%20K1-K12%20-%20104.06%20m2/Publish%20N3/",
      "8": "https://hitimperial.github.io/vr-new/L3%20-%20K1-K12%20-%20104.06%20m2/Publish%20N3/",
      "9": "https://hitimperial.github.io/vr-new/L3%20-%20K1-K12%20-%20104.06%20m2/Publish%20N3/",
      "10": "https://hitimperial.github.io/vr-new/L3%20-%20K1-K12%20-%20104.06%20m2/Publish%20n4/",
      "11": "https://hitimperial.github.io/vr-new/L3%20-%20K1-K12%20-%20104.06%20m2/Publish%20n4/",
      "12": "https://hitimperial.github.io/vr-new/L3%20-%20K1-K12%20-%20104.06%20m2/Publish%20n4/"
    }
  },
  {
    id: "A-03-K3",
    path: "M550 544V769H716.5V544H550Z", 
    link: "/detajet-a03",
    images: [
      "/images/Bazat 2D dhe 3D k3&4/L3/L3 -K1-K12 -03.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K3 - Foto VR/01.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K3 - Foto VR/02.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K3 - Foto VR/03.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K3 - Foto VR/04.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K3 - Foto VR/05.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K3 - Foto VR/06.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K3 - Foto VR/07.jpg"
    ],
    vrPaths: {
      "1": "https://hitimperial.github.io/vr-new/%E2%80%A2%206%20-%20Tipi%2003%20-%20K3/Tipi%2003%20-%20N1%20K3%20-%20Kati%201-2-3/",
      "2": "https://hitimperial.github.io/vr-new/%E2%80%A2%206%20-%20Tipi%2003%20-%20K3/Tipi%2003%20-%20N1%20K3%20-%20Kati%201-2-3/",
      "3": "https://hitimperial.github.io/vr-new/%E2%80%A2%206%20-%20Tipi%2003%20-%20K3/Tipi%2003%20-%20N1%20K3%20-%20Kati%201-2-3/",
      "4": "https://hitimperial.github.io/vr-new/%E2%80%A2%206%20-%20Tipi%2003%20-%20K3/Tipi%2003%20-%20N2%20K3%20-%20Kati%204-5-6/",
      "5": "https://hitimperial.github.io/vr-new/%E2%80%A2%206%20-%20Tipi%2003%20-%20K3/Tipi%2003%20-%20N2%20K3%20-%20Kati%204-5-6/",
      "6": "https://hitimperial.github.io/vr-new/%E2%80%A2%206%20-%20Tipi%2003%20-%20K3/Tipi%2003%20-%20N2%20K3%20-%20Kati%204-5-6/",
      "7": "https://hitimperial.github.io/vr-new/%E2%80%A2%206%20-%20Tipi%2003%20-%20K3/Tipi%2003%20-%20N3%20K3%20-%20Kati%207-8-9/",
      "8": "https://hitimperial.github.io/vr-new/%E2%80%A2%206%20-%20Tipi%2003%20-%20K3/Tipi%2003%20-%20N3%20K3%20-%20Kati%207-8-9/",
      "9": "https://hitimperial.github.io/vr-new/%E2%80%A2%206%20-%20Tipi%2003%20-%20K3/Tipi%2003%20-%20N3%20K3%20-%20Kati%207-8-9/",
      "10": "https://hitimperial.github.io/vr-new/%E2%80%A2%206%20-%20Tipi%2003%20-%20K3/Tipi%2003%20-%20N4%20K3%20-%20Kati%2010-11-12/",
      "11": "https://hitimperial.github.io/vr-new/%E2%80%A2%206%20-%20Tipi%2003%20-%20K3/Tipi%2003%20-%20N4%20K3%20-%20Kati%2010-11-12/",
      "12": "https://hitimperial.github.io/vr-new/%E2%80%A2%206%20-%20Tipi%2003%20-%20K3/Tipi%2003%20-%20N4%20K3%20-%20Kati%2010-11-12/"
    }
  },
  {
    id: "A-02-K3",
    path: "M236 517V308l284.5-1v186h-92.5v24H236z", 
    link: "/detajet-a02",
    images: [
      "/images/Bazat 2D dhe 3D k3&4/L3/L3 -K1 -05.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/01.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/02.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/03.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/04.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/05.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/06.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/07.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/08.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/09.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/10.jpg"
    ],
    vrPaths: {
      "1": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N1%20-%20Terasat/", 
      "2": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N1/",
      "3": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N1/",
      "4": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N2/",
      "5": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N2/",
      "6": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N2/",
      "7": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N3/",
      "8": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N3/",
      "9": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N3/",
      "10": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N4/",
      "11": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N4/",
      "12": "https://hitimperial.github.io/vr-new/%E2%80%A2%205%20-%20Tip%2002-K3/Publish%20N4/"
    }
  },
  {
    id: "A-01-K3",
    path: "M551 543.5v227H236v-253l193 2v24H551z", 
    link: "/detajet-a01",
    images: [
      "/images/Bazat 2D dhe 3D k3&4/L3/L3 -K1-K12 -04.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 01 - K3 - Foto VR/01.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 01 - K3 - Foto VR/02.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 01 - K3 - Foto VR/03.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 01 - K3 - Foto VR/04.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 01 - K3 - Foto VR/05.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 01 - K3 - Foto VR/06.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 01 - K3 - Foto VR/07.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 01 - K3 - Foto VR/08.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 01 - K3 - Foto VR/09.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 01 - K3 - Foto VR/10.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 01 - K3 - Foto VR/11.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 01 - K3 - Foto VR/12.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 01 - K3 - Foto VR/13.jpg",
      "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 01 - K3 - Foto VR/14.jpg"
    ],
    vrPaths: {
      "1": "https://hitimperial.github.io/vr-new/%E2%80%A2%204%20-%20Tipi%2001%20-%20K3/Tipi%2001%20-%20N1%20K3%20-%20Kati%201-2-3/",
      "2": "https://hitimperial.github.io/vr-new/%E2%80%A2%204%20-%20Tipi%2001%20-%20K3/Tipi%2001%20-%20N1%20K3%20-%20Kati%201-2-3/",
      "3": "https://hitimperial.github.io/vr-new/%E2%80%A2%204%20-%20Tipi%2001%20-%20K3/Tipi%2001%20-%20N1%20K3%20-%20Kati%201-2-3/",
      "4": "https://hitimperial.github.io/vr-new/%E2%80%A2%204%20-%20Tipi%2001%20-%20K3/Tipi%2001%20-%20N2%20K3%20-%20Kati%204-5-6/",
      "5": "https://hitimperial.github.io/vr-new/%E2%80%A2%204%20-%20Tipi%2001%20-%20K3/Tipi%2001%20-%20N2%20K3%20-%20Kati%204-5-6/",
      "6": "https://hitimperial.github.io/vr-new/%E2%80%A2%204%20-%20Tipi%2001%20-%20K3/Tipi%2001%20-%20N2%20K3%20-%20Kati%204-5-6/",
      "7": "https://hitimperial.github.io/vr-new/%E2%80%A2%204%20-%20Tipi%2001%20-%20K3/Tipi%2001%20-%20N3%20K3%20-%20Kati%207-8-9/",
      "8": "https://hitimperial.github.io/vr-new/%E2%80%A2%204%20-%20Tipi%2001%20-%20K3/Tipi%2001%20-%20N3%20K3%20-%20Kati%207-8-9/",
      "9": "https://hitimperial.github.io/vr-new/%E2%80%A2%204%20-%20Tipi%2001%20-%20K3/Tipi%2001%20-%20N3%20K3%20-%20Kati%207-8-9/",
      "10": "https://hitimperial.github.io/vr-new/%E2%80%A2%204%20-%20Tipi%2001%20-%20K3/Tipi%2001%20-%20N4%20K3%20-%20Kati%2010-11-12/",
      "11": "https://hitimperial.github.io/vr-new/%E2%80%A2%204%20-%20Tipi%2001%20-%20K3/Tipi%2001%20-%20N4%20K3%20-%20Kati%2010-11-12/",
      "12": "https://hitimperial.github.io/vr-new/%E2%80%A2%204%20-%20Tipi%2001%20-%20K3/Tipi%2001%20-%20N4%20K3%20-%20Kati%2010-11-12/"
    }
  }
];

function SameFloors34() {
  const [hoveredId, setHoveredId] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const containerRef = useRef(null);
  const { customFloorUrl, tower } = location.state || { customFloorUrl: "", tower: "" };
  const floorNumber = customFloorUrl ? String(customFloorUrl) : "";
  const activeFloorNumber = floorNumber || "1";
  const fromTower = tower || "";

  const getVrPathForFloor = (zona) => {
    if (zona.vrPaths && zona.vrPaths[activeFloorNumber]) {
      return zona.vrPaths[activeFloorNumber];
    }
    return zona.vrPath || "";
  };

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setSelectedId(null);
      }
    };
    if (isMobile && selectedId) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => document.removeEventListener("click", handleClickOutside);
  }, [isMobile, selectedId]);

  const handleZoneClick = (zona) => (e) => {
    e.preventDefault();

    // Mobile: kliki i parë selekton, kliki i dytë navigon
    if (isMobile && selectedId !== zona.id) {
      setSelectedId(zona.id);
      return;
    }
    setSelectedId(null);

    let selectedImages = zona.images;

    if (zona.id === "B-01-K4") {
      const vrPhotosT02K4 = [
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/01.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/02.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/03.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/04.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/05.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/06.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/07.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/08.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/09.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/10.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/11.jpg"
      ];
      selectedImages = (activeFloorNumber === "1") 
        ? ["/images/Bazat 2D dhe 3D k3&4/L4/L4 -K1 -05.jpg", ...vrPhotosT02K4] 
        : ["/images/Bazat 2D dhe 3D k3&4/L4/L4 -K2-K12 -11.jpg", ...vrPhotosT02K4];
    }

    if (zona.id === "B-02-K4") {
      const vrPhotosT03K4 = [
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/01.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/02.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/03.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/04.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/05.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/06.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/07.jpg"
      ];
      selectedImages = (activeFloorNumber === "1") 
        ? ["/images/Bazat 2D dhe 3D k3&4/L4/L4 -K1 -06.jpg", ...vrPhotosT03K4] 
        : ["/images/Bazat 2D dhe 3D k3&4/L4/L4 -K2-K12 -12.jpg", ...vrPhotosT03K4];
    }

    if (zona.id === "B-05-K4") {
      const vrPhotosT03K4 = [
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/01.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/02.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/03.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/04.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/05.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/06.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 03 - K4 - Foto VR/07.jpg"
      ];
      selectedImages = (activeFloorNumber === "1") 
        ? ["/images/Bazat 2D dhe 3D k3&4/L4/L4 -K1 -01.jpg", ...vrPhotosT03K4] 
        : ["/images/Bazat 2D dhe 3D k3&4/L4/L4 -K1-K12 -07.jpg", ...vrPhotosT03K4];
    }

    if (zona.id === "A-02-K3") {
      const vrPhotosK3 = [
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/01.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/02.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/03.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/04.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/05.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/06.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/07.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/08.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/09.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K3 - Fotot VR/10.jpg"
      ];
      selectedImages = (activeFloorNumber === "1") 
        ? ["/images/Bazat 2D dhe 3D k3&4/L3/L3 -K1 -05.jpg", ...vrPhotosK3] 
        : ["/images/Bazat 2D dhe 3D k3&4/L3/L3 -K2-K12 -10.jpg", ...vrPhotosK3];
    }

    if (zona.id === "A-04-K3") {
      selectedImages = (activeFloorNumber === "1")
        ? ["/images/Bazat 2D dhe 3D k3&4/L3/L3 -K1 -01.jpg"]
        : ["/images/Bazat 2D dhe 3D k3&4/L3/L3 -K1-K12 -06.jpg"];
    }

    if (zona.id === "B-06-K4") {
      const vrPhotosT02K4 = [
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/01.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/02.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/03.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/04.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/05.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/06.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/07.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/08.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/09.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/10.jpg",
        "/images/Bazat 2D dhe 3D k3&4/Foto VR per Postim/Tipi 02 - K4 - Foto VR/11.jpg"
      ];
      selectedImages = (activeFloorNumber === "1") 
        ? ["/images/Bazat 2D dhe 3D k3&4/L4/L4 -K1 -02.jpg", ...vrPhotosT02K4] 
        : ["/images/Bazat 2D dhe 3D k3&4/L4/L4 -K2-K12 -08.jpg", ...vrPhotosT02K4];
    }

    if (selectedImages && Array.isArray(selectedImages) && selectedImages.length > 0) {
      navigate("/navigate-floor", { 
        state: { 
          customUrl1: "", 
          customUrl2: zona.id, 
          vrPath: getVrPathForFloor(zona), 
          customUrl3: activeFloorNumber,
          images: selectedImages 
        } 
      });
      return;
    }
    
    navigate(zona.link);
  };

  return (
    <div className="relative w-full mt-40 mb-40 flex justify-center">
      <div ref={containerRef} className="relative w-full max-w-[1920px]"> 
        <img
          className='w-full h-auto block'
          src={activeFloorNumber === '13'
            ? "/images/click/clickable-images/Floors/Direct-floors/clean-floors/Penthouse34.jpg"
            : "/images/click/clickable-images/Floors/Direct-floors/clean-floors/SameFloors3&4.jpg"}
          alt="Floor Plan a"
        />
        {activeFloorNumber === '13' ? (
          <>
            {fromTower !== 'K4' && <PHK3 floorNumber={floorNumber} />}
            {fromTower !== 'K3' && <PHK4 floorNumber={floorNumber} />}
          </>
        ) : (
          <svg
            viewBox="0 0 1920 1080" 
            className="absolute top-0 left-0 w-full h-full"
            style={{ pointerEvents: 'none', zIndex: 20 }}
            preserveAspectRatio="none"
          >
            {zonatData.map((zona) => {
              const isActive = isMobile
                ? selectedId === zona.id
                : hoveredId === zona.id || selectedId === zona.id;
              return (
                <g
                  key={zona.id}
                  onClick={handleZoneClick(zona)}
                  onMouseEnter={() => { if (!isMobile) setHoveredId(zona.id); }}
                  onMouseLeave={() => { if (!isMobile) setHoveredId(null); }}
                  style={{ pointerEvents: 'all', cursor: 'pointer' }}
                >
                  <path
                    d={zona.path}
                    fill={isActive ? 'rgba(104, 172, 73, 0.5)' : 'transparent'}
                    stroke={isActive ? '#3A6626' : 'transparent'}
                    strokeWidth="1"
                    className="transition-all duration-300 ease-in-out"
                  />
                </g>
              );
            })}
          </svg>
        )}
      </div>
    </div>
  );
}

export default SameFloors34;
